import React, { useState } from "react";
import { useDispatch } from "react-redux";
import * as Yup from "yup";

//---> Internal Import
import { FtextField } from "../../../../components/common/FtextField";
import Loader from "../../../../components/common/Loader";
import { updateOwner } from "../../../../features/apiCallAdmin";
import { Field, Form, Formik } from "formik";

//---> DEFAULT VALUE
let initialValues = {
  username: "",
  password: "",
  orderPerfix: "",
  shurjoPay: false,
  hasPG: true,
};

const ShurjoPayForm = ({ setShow, ispOwner }) => {
  const dispatch = useDispatch();

  //---> Local State
  const [isLoading, setIsLoading] = useState(false);
  const [passType, setPassType] = useState("password");

  if (ispOwner) {
    const paymentGateway = ispOwner?.bpSettings?.paymentGateway;
    if (paymentGateway?.shurjoPay) {
      initialValues = {
        username: paymentGateway?.shurjoPay?.username,
        password: paymentGateway?.shurjoPay?.password,
        orderPerfix: paymentGateway?.shurjoPay?.orderPerfix,
        shurjoPay: paymentGateway?.providers?.shurjoPay,
      };
    }

    if (paymentGateway)
      initialValues = { ...initialValues, hasPG: ispOwner?.bpSettings?.hasPG };
  }

  const ispShurjoPayValidator = Yup.object({
    username: Yup.string().required(),
    password: Yup.string().required(),
    orderPerfix: Yup.string().required(),
    hasPG: Yup.boolean(),
  });

  const shurjoPayHandler = (values) => {
    let postBody = {
      ...ispOwner,
      bpSettings: {
        ...ispOwner.bpSettings,
        paymentGateway: {
          ...ispOwner.bpSettings.paymentGateway,
          gatewayType: "shurjoPay",
          shurjoPay: {
            username: values.username,
            password: values.password,
            orderPerfix: values.orderPerfix,
          },
          providers: {
            ...ispOwner.bpSettings.paymentGateway?.providers,
            shurjoPay: values.shurjoPay,
          },
        },
        hasPG: values.hasPG,
      },
    };

    updateOwner(ispOwner.id, postBody, setIsLoading, dispatch, setShow);
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={ispShurjoPayValidator}
      onSubmit={(values) => {
        shurjoPayHandler(values);
      }}
      enableReinitialize
    >
      {() => (
        <Form>
          <div className="displayGrid3">
            <FtextField
              type="text"
              label="Username"
              name="username"
              validation={true}
            />

            <FtextField
              type="text"
              label="Password"
              name="password"
              validation={true}
            />

            <FtextField
              type="text"
              label="Order Perfix"
              name="orderPerfix"
              validation={true}
            />
          </div>

          <div className="displayGrid3">
            <div className="form-check mt-4">
              <Field
                className="form-check-input"
                type="checkbox"
                id="shurjoPay"
                name="shurjoPay"
              />
              <label className="form-check-label" for="shurjoPay">
                Has Gateway<span className="text-danger ms-1">*</span>
              </label>
            </div>

            <div className="form-check mt-4">
              <Field
                className="form-check-input"
                type="checkbox"
                id="hasPG"
                name="hasPG"
              />
              <label className="form-check-label" for="hasPG">
                Has PG
              </label>
            </div>
          </div>

          <div className="displayGrid1 float-end mt-4">
            <button
              type="button"
              className="btn btn-secondary"
              disabled={isLoading}
              onClick={() => setShow(false)}
            >
              Cancel
            </button>

            <button
              type="submit"
              className="btn btn-success"
              disabled={isLoading}
            >
              {isLoading ? <Loader /> : "Submit"}
            </button>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default ShurjoPayForm;
